/* Custom jersey: rozdělaný návrh se drží v localStorage (30 dní).
   Při návratu nabídne bílý box na středu 3D náhledu: Pokračovat / Začít znovu.

   Běží nezávisle na 3D (WebGL): obnova zaškrtne uložené volby a dosadí jméno a
   dispatchne 'change'/'input'/'keyup', takže si to konfigurator (3D náhled) i
   readiness checklist samy dopočítají. Konfigurator navíc čte zaškrtnuté volby
   i jméno při vlastní inicializaci, takže obnova funguje bez ohledu na to, jestli
   uživatel klikne dřív nebo později než doběhne načtení 3D.

   POZOR: skript se NAČÍTÁ MIMO product form. Udesly parsuje první <script> uvnitř
   formu jako JSON s konfigurací variant a inline skript ve formu rozbije add-to-cart. */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'thtd_cpo_design_';
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 dní
  var SAVE_DEBOUNCE_MS = 400;
  var SCHEMA_VERSION = 1;

  // Texty podle jazyka stránky (CZ default, EN pro /en/)
  var isEn = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('en') === 0;
  var T = isEn
    ? { text: 'You have an unfinished design here.', cont: 'Continue', restart: 'Start over' }
    : { text: 'Máš tu rozdělaný návrh z minula.', cont: 'Pokračovat', restart: 'Začít znovu' };

  // Bezpečné localStorage (může házet v privátním režimu / při vypnutém úložišti)
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsRemove(k) { try { window.localStorage.removeItem(k); } catch (e) {} }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var form = document.querySelector('form[data-node-type="commerce-add-to-cart-form"]');
    var optionsRoot = document.querySelector('.cpo-options');
    if (!form || !optionsRoot) { return; } // nejsme na stránce s custom options

    var inputs = Array.prototype.slice.call(optionsRoot.querySelectorAll('input[data-field-name]'));
    if (!inputs.length) { return; }

    // Velikost je Shopify varianta (ne custom option): skryté <select name="optionN">
    // řízené „pilulkami". Udesly na kliknutí pilulky dělá select.value = handle +
    // dispatch 'change', na což si přepočítá variantu (cena/dostupnost/id do košíku).
    var variantSelects = Array.prototype.slice.call(
      form.querySelectorAll('select[data-node-type="add-to-cart-option-select"]')
    );

    var preview = document.querySelector('.cpo-3d-sticky') || document.querySelector('.product_3d_wrapper');

    // Klíč per design: metafield _design (hidden input), fallback dle URL produktu
    var designInput = form.querySelector('input[name="properties[_design]"]');
    var designKey = (designInput && designInput.value)
      ? designInput.value
      : ((location.pathname.split('/products/')[1] || 'default').split('/')[0]);
    var storageKey = STORAGE_PREFIX + designKey;

    var isRestoring = false; // true během programové obnovy → neukládat ani neschovávat box
    var saveTimer = null;
    // Dokud neproběhne obnova velikosti (Udesly startuje později), drží uloženou
    // velikost, aby brzká editace barvy/jména nepřeuložila draft výchozí velikostí.
    var pendingVariant = null;

    function snapshot() {
      var fields = {};
      inputs.forEach(function (el) {
        if (el.type === 'radio') {
          if (el.checked) { fields[el.name] = el.value; }
        } else if ((el.value || '') !== '') {
          fields[el.name] = el.value;
        }
      });
      var variant;
      if (pendingVariant) {
        // velikost se ještě neobnovila → drž uloženou (select je zatím výchozí)
        variant = pendingVariant;
      } else {
        variant = {};
        variantSelects.forEach(function (sel) {
          if (sel.value) { variant[sel.name] = sel.value; }
        });
      }
      return { fields: fields, variant: variant };
    }

    function save() {
      var snap = snapshot();
      // Draft držíme jen když je vybraná aspoň jedna custom volba (barva/jméno).
      // Velikost je vždy přednastavená, takže sama o sobě „rozdělaný návrh" nedělá;
      // ukládá se ale jako součást draftu, když nějaká custom volba je.
      if (!Object.keys(snap.fields).length) { lsRemove(storageKey); return; }
      lsSet(storageKey, JSON.stringify({ v: SCHEMA_VERSION, ts: Date.now(), fields: snap.fields, variant: snap.variant }));
    }

    function loadSaved() {
      var raw = lsGet(storageKey);
      if (!raw) { return null; }
      var data;
      try { data = JSON.parse(raw); } catch (e) { lsRemove(storageKey); return null; }
      if (!data || data.v !== SCHEMA_VERSION || !data.fields || !Object.keys(data.fields).length) {
        lsRemove(storageKey); return null;
      }
      if (typeof data.ts !== 'number' || (Date.now() - data.ts) > MAX_AGE_MS) {
        lsRemove(storageKey); return null; // vypršelo (30 dní)
      }
      return data;
    }

    function fire(el, types) {
      types.forEach(function (t) {
        el.dispatchEvent(new Event(t, { bubbles: true }));
      });
    }

    // Počkej, až Udesly zinicializuje formulář (nastaví form.dataset.udeslyInit),
    // pak teprve obnov velikost — jinak by ji Udesly initem (alignSelect) přepsal
    // zpět na výchozí variantu.
    function whenUdeslyReady(cb) {
      if (form.dataset.udeslyInit === 'true') { cb(); return; }
      var tries = 0;
      var iv = setInterval(function () {
        if (form.dataset.udeslyInit === 'true' || ++tries > 120) { // ~6 s strop
          clearInterval(iv);
          cb();
        }
      }, 50);
    }

    function restoreVariant(variant) {
      if (!variant) { return; }
      variantSelects.forEach(function (sel) {
        var saved = variant[sel.name];
        if (saved == null || saved === '' || sel.value === saved) { return; }
        // ověř, že hodnota v selectu pořád existuje (velikost mohla z produktu zmizet)
        var has = Array.prototype.some.call(sel.options, function (o) { return o.value === saved; });
        if (!has) { return; }
        // stejné jako klik na pilulku: Udesly si přepočítá variantu (cena/dostupnost/id)
        sel.value = saved;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function restore(data) {
      isRestoring = true;
      try {
        Object.keys(data.fields).forEach(function (name) {
          var val = data.fields[name];
          var group = inputs.filter(function (el) { return el.name === name; });
          if (!group.length) { return; }
          if (group[0].type === 'radio') {
            group.forEach(function (r) {
              if (r.value === val && !r.checked) {
                r.checked = true;
                fire(r, ['change', 'input']);
              }
            });
          } else {
            var txt = group[0];
            if (txt.value !== val) {
              txt.value = val;
              fire(txt, ['input', 'keyup', 'change']);
            }
          }
        });
      } finally {
        isRestoring = false;
      }
      // Velikost obnovíme až po init Udesly (viz whenUdeslyReady). Úložiště už
      // správný stav má (uložil ho uživatel při editaci), takže tady nic nepřeukládáme.
      if (variantSelects.length && data.variant && Object.keys(data.variant).length) {
        pendingVariant = data.variant; // než Udesly naběhne, ukládej tuhle velikost
        whenUdeslyReady(function () {
          isRestoring = true;
          try { restoreVariant(data.variant); } finally { isRestoring = false; }
          pendingVariant = null; // teď už select drží obnovenou velikost
        });
      }
    }

    /* ---------- Bílá karta na středu 3D náhledu (po automatickém načtení) ----------
       Design se načte rovnou; karta jen potvrzuje „máš tu rozdělaný návrh z minula".
       Pokračovat = zavřít a nechat načtené; Začít znovu = vynulovat na čisto (reload).
       Karta zmizí i při editaci voleb a při první interakci s 3D náhledem, aby
       nezakrývala načtený dres. */
    var box = null;

    function showNotice() {
      if (!preview || box) { return; }
      box = document.createElement('div');
      box.className = 'cpo-resume';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-label', T.text);
      box.innerHTML =
        '<div class="cpo-resume__card">' +
          '<p class="cpo-resume__text"></p>' +
          '<div class="cpo-resume__actions">' +
            '<button type="button" class="cpo-resume__btn cpo-resume__btn--primary" data-cpo-resume="continue"></button>' +
            '<button type="button" class="cpo-resume__btn" data-cpo-resume="restart"></button>' +
          '</div>' +
        '</div>';
      // textContent (ne innerHTML) kvůli bezpečnému vložení textů
      box.querySelector('.cpo-resume__text').textContent = T.text;
      box.querySelector('[data-cpo-resume="continue"]').textContent = T.cont;
      box.querySelector('[data-cpo-resume="restart"]').textContent = T.restart;

      box.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cpo-resume]');
        if (!btn) { return; }
        if (btn.getAttribute('data-cpo-resume') === 'restart') {
          lsRemove(storageKey);
          try { window.location.reload(); return; } catch (e2) {}
        }
        hideBox(); // Pokračovat → jen zavřít, načtený design necháme
      });
      preview.appendChild(box);

      // Zavřít nabídku i při první interakci s 3D náhledem (rotace/klik)
      var canvas = document.getElementById('canvas-3d');
      if (canvas) { canvas.addEventListener('pointerdown', hideBox, { once: true }); }
    }

    function hideBox() {
      if (box && box.parentNode) { box.parentNode.removeChild(box); }
      box = null;
    }

    /* ---------- Ukládání + zavření nabídky při vlastní editaci ---------- */
    function onUserEdit() {
      if (isRestoring) { return; }
      if (box) { hideBox(); } // začal jsi sám upravovat → nabídku schovej (bereme jako nový návrh)
      clearTimeout(saveTimer);
      saveTimer = setTimeout(save, SAVE_DEBOUNCE_MS);
    }
    optionsRoot.addEventListener('change', onUserEdit);
    optionsRoot.addEventListener('input', onUserEdit);
    // Změna velikosti (pilulka → 'change' na skrytém selectu) taky uloží draft
    variantSelects.forEach(function (sel) { sel.addEventListener('change', onUserEdit); });

    /* ---------- Rozdělaný návrh smažeme až po POTVRZENÉM přidání do košíku ----------
       Ne optimisticky na klik: kdyby přidání selhalo (vyprodaná velikost, síť, 422),
       o rozdělaný návrh bychom přišli, přesně to čemu má feature bránit. Udesly přidává
       přes fetch('/cart/add.js') a při ne-200 hází chybu → obalíme fetch a draft smažeme
       jen při ÚSPĚŠNÉ (res.ok) odpovědi na POST /cart/add. Čteme jen res.ok, tělo
       odpovědi nekonzumujeme, takže udesly zpracování zůstane nedotčené. */
    (function hookCartAdd() {
      if (window.__thtdCartAddHook) { return; }
      var orig = window.fetch;
      if (typeof orig !== 'function') { return; }
      window.__thtdCartAddHook = true;
      window.fetch = function (input, init) {
        var ret = orig.apply(this, arguments);
        try {
          var url = (typeof input === 'string') ? input : (input && input.url) || '';
          var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
          if (method === 'POST' && /\/cart\/add(\.js)?($|\?)/i.test(url)) {
            ret.then(function (res) {
              if (res && res.ok) { lsRemove(storageKey); }
            }).catch(function () {});
          }
        } catch (e) {}
        return ret;
      };
    })();

    /* ---------- Start: rovnou načíst uložený design + lehká nabídka ---------- */
    var saved = loadSaved();
    if (saved) {
      restore(saved);   // konfigurator si zaškrtnuté volby i jméno přečte při své inicializaci
      showNotice();     // + karta „načetli jsme tvůj návrh" se Začít znovu
    }
  });
})();
